import shopsy from './Shopsy.JPG';
import portfolio from './Portfolio.JPG';
import filmify from './filmify.JPG';
import drummach from './drum-mach.JPG';
import clock from './clock.JPG';
import cryptoly from './cryptoly.PNG';
export const projectsData = [
    {
        projectName: 'Shopsy',
        projectDescription:
            'An Ecommerce project created using Reactjs, Redux for state management and firebase for authentication. Payment option integrated using strapi',
        imageUrl: shopsy,
        id:1,
        projectUrl: 'https://react-shopsy.herokuapp.com/',
        sourceCodeLink:'https://github.com/preetchani/shopsy',
    },
    {
        projectName: 'Cryptoly',
        projectDescription:
            'A CryptoCurrency App to check latest status of different crypto currencies. This project is created using react, redux toolkit, Ant Design and data fetched using RepidApi ',
        imageUrl: cryptoly,
        id:6,
        projectUrl: 'https://cryptoly.vercel.app/',
        sourceCodeLink:'https://github.com/preetchani/cryptoly',
    },

    {
        projectName: 'Portfolio Website',
        projectDescription:
            'As a developer/designer, we should definitely have our own portfolio website. I have created this project using Reactjs ',
        imageUrl: portfolio,
        id:2,
        projectUrl: 'https://gurpreet-singh.vercel.app/',
    },
    {
        projectName: 'Filmify',
        projectDescription:
            'A Movie Search App created using ReactJs, styled components and TMDB API',
        imageUrl: filmify,
        id:3,
        projectUrl: 'https://react-filmify.netlify.app/',
        sourceCodeLink:'https://github.com/preetchani/Filmify',
    },
    {
        projectName: 'Drum-Mach',
        projectDescription:
            'A Mini Drum machine created using Reactjs. user can switch between 2 modes and use slidebar to increase or decrease volume',
        imageUrl: drummach,
        id:4,
        projectUrl: 'https://drum-mach.vercel.app/',
        sourceCodeLink:'https://github.com/preetchani/drum-mach',
    },
    {
        projectName: 'Campass-Clock',
        projectDescription:
            'This Project shows current date time in campass clock format. Project Createed using Reactjs',
        imageUrl: clock,
        id:5,
        projectUrl: 'https://react-compass-clock.netlify.app/',
        sourceCodeLink:'https://github.com/preetchani/Compass-clock',
    },
];
